import { render, staticRenderFns } from "./payment-method-selector.vue?vue&type=template&id=21111b79&lang=pug&"
import script from "./payment-method-selector.vue?vue&type=script&lang=js&"
export * from "./payment-method-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports